import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AuthButton.css';

const AuthButton: React.FC = () => {
  const { user, signInWithGoogle, signOut } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  if (!user) {
    return (
      <button onClick={signInWithGoogle} className="auth-btn sign-in-btn">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
          <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.18L12.05 13.56c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18z" fill="#34A853"/>
          <path d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
          <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.426 0 9.003 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71z" fill="#EA4335"/>
        </svg>
        Sign in with Google
      </button>
    );
  }

  return (
    <div className="user-menu">
      <button onClick={() => setShowMenu(!showMenu)} className="user-btn">
        {user.user_metadata?.avatar_url ? (
          <img src={user.user_metadata.avatar_url} alt="Profile" className="user-avatar" />
        ) : (
          <div className="user-avatar-placeholder">
            {user.email?.charAt(0).toUpperCase()}
          </div>
        )}
      </button>
      {showMenu && (
        <div className="user-dropdown">
          <div className="user-info">
            <div className="user-name">{user.email}</div>
          </div>
          <button onClick={() => { navigate('/favorites'); setShowMenu(false); }} className="menu-item">
            ❤️ My Favorites
          </button>
          <button onClick={() => { navigate('/preferences'); setShowMenu(false); }} className="menu-item">
            ⚙️ Preferences
          </button>
          <button onClick={signOut} className="menu-item sign-out">
            🚪 Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default AuthButton;
